import { Property } from "./interfaces";

export const codConsulta: Property = { title: "Código de Consulta", type: "string" }